import {Component, inject, Input, OnInit} from '@angular/core';
import {
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardTitle,
    IonChip,
    IonIcon,
    IonRow, IonSpinner
} from '@ionic/angular/standalone';
import {
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderCellDef, MatHeaderRow, MatHeaderRowDef,
    MatRow, MatRowDef,
    MatTable
} from '@angular/material/table';
import {MatRipple} from '@angular/material/core';
import {Router} from '@angular/router';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {BaseError} from '../../../models/error/BaseError';
import {NavigationVisitor} from '../../../models/navigation/NavigationVisitor';
import {ErrorNavigationVisitor} from '../../../models/navigation/ErrorNavigationVisitor';

@Component({
    selector: 'app-dashboard-log-list',
    templateUrl: './dashboard-log-list.component.html',
    styleUrls: ['./dashboard-log-list.component.css'],
    standalone: true,
    imports: [
        IonCard,
        IonCardHeader,
        IonCardTitle,
        IonCardContent,
        MatTable,
        MatColumnDef,
        MatHeaderCell,
        MatCell,
        MatCellDef,
        MatHeaderCellDef,
        MatRow,
        MatRowDef,
        MatRipple,
        IonChip,
        TranslatePipe,
        IonIcon,
        MatHeaderRow,
        MatHeaderRowDef,
        IonSpinner,
        IonRow,
    ]
})
export class DashboardLogListComponent implements OnInit {
    private static readonly DEFAULT_LENGTH_ERROR_SUMMARY: number = 60;
    private static readonly MAX_LENGTH_ERROR_SUMMARY: number = 90;

    private readonly navigationVisitor: NavigationVisitor = inject(ErrorNavigationVisitor);
    protected columnsToDisplay: string[] = [];
    protected router: Router = inject(Router);

    @Input({ required: true }) errors: BaseError[] = [];
    @Input({ required: true }) title!: string;
    @Input({ required: true }) loading: boolean = false;
    @Input() showTenantName: boolean = false;

    constructor() {
    }

    ngOnInit() {
        this.columnsToDisplay.push(...this.getColumnsToDisplay());
    }

    private getColumnsToDisplay(): string[] {
        const columnsToDisplay: string[] = [];
        if (this.showTenantName)
            columnsToDisplay.push('tenantName');

        columnsToDisplay.push(...['tenantApplicationName', 'contentSummary', 'mostRecentOccurred', 'occurrenceCount']);
        return columnsToDisplay;
    }

    protected goToLogBookDetails(error: BaseError) {
        error.accept(this.navigationVisitor, true);
    }

    protected get lengthErrorSummary(): number {
        return this.showTenantName ? DashboardLogListComponent.DEFAULT_LENGTH_ERROR_SUMMARY : DashboardLogListComponent.MAX_LENGTH_ERROR_SUMMARY;
    }
}
